// extracted by mini-css-extract-plugin
export default {"operation_white":"Operation_operation_white__r0oEp","operation":"Operation_operation__vyDS3"};